module.exports = __webpack_public_path__ + "img/bank-download-transactions-disabled.5eada48c.svg";